const SetLoader = (data) => ({ type: 'SET', data });
export { SetLoader };
